import { render } from "./CombatLogConnection.vue?vue&type=template&id=4d959890"
import script from "./CombatLogConnection.vue?vue&type=script&lang=js"
export * from "./CombatLogConnection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__